var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisaWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2295_68309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4809 17.8211C20.465 19.486 21.6034 20.4151 22.461 20.9675C23.3422 21.5343 23.6381 21.8977 23.6346 22.4046C23.6281 23.1803 22.9318 23.5227 22.2803 23.536C21.1435 23.5592 20.4826 23.1303 19.9571 22.8058L19.5476 25.3387C20.0748 25.6598 21.051 25.9399 22.0632 25.9521C24.4394 25.9521 25.994 24.4017 26.0024 21.9978C26.0117 18.9469 22.81 18.778 22.8318 17.4144C22.8394 17.0009 23.1379 16.5596 23.7919 16.4474C24.1157 16.3908 25.0094 16.3474 26.0226 16.9641L26.4203 14.5135C25.8754 14.2513 25.1751 14.0002 24.3031 14.0002C22.0666 14.0002 20.4936 15.5717 20.4809 17.8211ZM30.2417 14.2112C29.8078 14.2112 29.4421 14.5458 29.2789 15.0592L25.8847 25.7721H28.2591L28.7316 24.046H31.6331L31.9072 25.7721H34L32.1738 14.2112H30.2417ZM30.5738 17.3343L31.2591 21.6755H29.3824L30.5738 17.3343ZM17.6021 14.2114L15.7304 25.772H17.9931L19.8638 14.2111H17.6021M14.2549 14.2111L11.8998 22.0801L10.9471 15.3894C10.8354 14.6425 10.3939 14.2112 9.9037 14.2112H6.05392L6 14.5469C6.79034 14.7736 7.68831 15.1393 8.23234 15.5305C8.56528 15.7695 8.66022 15.9784 8.76959 16.5463L10.574 25.7721H12.965L16.6308 14.2112L14.2549 14.2111Z",
    fill: "url(#paint0_linear_2295_68309)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2295_68309",
    x1: 18.8727,
    y1: 26.1919,
    x2: 19.3298,
    y2: 13.9243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2295_68309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 12,
    fill: "white",
    transform: "translate(6 14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaWhite);
export default __webpack_public_path__ + "static/media/visa-white.ca1512cf1769da2fdcf80f6be3ac6729.svg";
export { ForwardRef as ReactComponent };